/* Slide Cart propio — Total Tools
 * Se sincroniza con CUALQUIER add-to-cart (grid, producto, quickshop, apps)
 * interceptando las llamadas de red a /cart/{add,change,update,clear} y
 * re-renderizando vía Section Rendering API. Sin dependencias.
 */
(function () {
  if (window.__ttCartDrawer) return;
  window.__ttCartDrawer = true;

  var SECTION_ID = 'cart-drawer';
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/i;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    var body = drawer.querySelector('[data-cart-drawer-body]');
    var lastFocus = null;
    var busy = false;

    /* ---------- abrir / cerrar ---------- */
    function open() {
      if (drawer.classList.contains('is-open')) return;
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cd-open');
      var close = drawer.querySelector('[data-cart-drawer-close]');
      if (close) close.focus();
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cd-open');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    /* ---------- barra de envío gratis (lee tt_loc, igual que el badge) ---------- */
    // Devuelve { comuna, threshold(pesos) } solo si la comuna tiene envío gratis
    // (freeShip===true, misma regla que tt-freeship-badge-init). Si no, null.
    function readFreeShip() {
      try {
        var o = JSON.parse(localStorage.getItem('tt_loc') || 'null');
        if (!o || !o.comuna || o.freeShip !== true) return null;
        var threshold = Number(o.threshold || 0);
        return threshold > 0 ? { comuna: o.comuna, threshold: threshold } : null;
      } catch (e) { return null; }
    }
    function escapeHtml(s) { var d = document.createElement('div'); d.textContent = String(s); return d.innerHTML; }
    function formatCLP(pesos) { return '$' + Math.round(pesos).toLocaleString('es-CL'); }

    function renderShip() {
      var el = drawer.querySelector('[data-cd-ship]');
      if (!el) return;
      var state = readFreeShip();
      if (!state) { el.hidden = true; el.innerHTML = ''; return; } // sin comuna con envío gratis → oculta
      var pesos = (parseInt(body.getAttribute('data-cart-total') || '0', 10)) / 100;
      var reached = pesos >= state.threshold;
      var pct = reached ? 100 : Math.max(2, Math.min(100, Math.round(pesos * 100 / state.threshold)));
      var comuna = escapeHtml(state.comuna);
      var msg = reached
        ? '🎉 ¡Tienes <strong>envío gratis</strong> a ' + comuna + '!'
        : 'Te faltan <strong>' + formatCLP(state.threshold - pesos) + '</strong> para <strong>envío gratis</strong> a ' + comuna;
      el.className = 'cd__ship' + (reached ? ' cd__ship--reached' : '');
      el.innerHTML = '<p class="cd__ship-txt">' + msg + '</p>' +
        '<div class="cd__ship-track"><div class="cd__ship-fill" style="width:' + pct + '%"></div></div>';
      el.hidden = false;
    }

    /* ---------- promesa de entrega por comuna (lee tt_loc.promise) ---------- */
    function renderDelivery() {
      var el = drawer.querySelector('[data-cd-delivery]');
      if (!el) return;
      var promise = '', zone = '';
      try {
        var o = JSON.parse(localStorage.getItem('tt_loc') || 'null');
        if (o) { promise = o.promise || ''; zone = o.zone || ''; }
      } catch (e) {}
      if (!promise) { el.hidden = true; el.innerHTML = ''; return; }
      var fast = zone === 'same_day';
      el.className = 'cd__delivery' + (fast ? ' cd__delivery--fast' : '');
      el.innerHTML = '<span class="cd__delivery-ico" aria-hidden="true">' + (fast ? '⚡' : '🚚') + '</span>' +
        '<span class="cd__delivery-txt">' + escapeHtml(promise) + '</span>';
      el.hidden = false;
    }

    /* ---------- sincroniza el contador del header ---------- */
    function syncHeaderCount(count) {
      var els = document.querySelectorAll('[data-header-cart-count]');
      els.forEach(function (el) {
        el.setAttribute('data-header-cart-count', count > 0 ? count : '');
        // El número lo pinta el CSS con ::after { content: attr(data-header-cart-count) }.
        // NO usar textContent aquí: duplicaba el número (texto plano + ::after) sobre el ícono.
        el.classList.toggle('visible', count > 0);
      });
    }

    /* ---------- re-render vía Section Rendering API ---------- */
    function refresh(openAfter) {
      return fetch('/?section_id=' + SECTION_ID, { headers: { 'Accept': 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cart-drawer-body]');
          if (fresh) {
            body.innerHTML = fresh.innerHTML;
            var count = parseInt(fresh.getAttribute('data-cart-count') || '0', 10);
            body.setAttribute('data-cart-count', count);
            body.setAttribute('data-cart-total', fresh.getAttribute('data-cart-total') || '0');
            syncHeaderCount(count);
            // El número del título del panel ("TU CARRITO n") está fuera del body que
            // se re-renderiza: sin esto quedaba en el valor de la carga de la página
            // (ej. "0" con 1 producto adentro).
            document.querySelectorAll('[data-cart-drawer-count]').forEach(function (c) { c.textContent = count; });
            // Avisar a empire.js (y a cualquier script que escuche) el nuevo item_count.
            // Sin esto, al eliminar/cambiar desde el drawer, empire mantenía su contador
            // viejo y el badge del header no se actualizaba. `_fromDrawer` evita el loop:
            // nuestro propio listener de cartcount:update lo ignora.
            document.dispatchEvent(new CustomEvent('cartcount:update', {
              detail: { item_count: count, _fromDrawer: true }
            }));
            renderShip();
            renderDelivery();
          }
          body.classList.remove('is-loading');
          busy = false;
          if (openAfter) open();
        })
        .catch(function (e) {
          console.warn('[cart-drawer] refresh falló', e);
          body.classList.remove('is-loading');
          busy = false;
        });
    }

    /* ---------- intercepta mutaciones del carrito (fetch) ---------- */
    var origFetch = window.fetch;
    if (origFetch) {
      window.fetch = function () {
        var input = arguments[0];
        var url = (input && input.url) ? input.url : String(input || '');
        var p = origFetch.apply(this, arguments);
        if (CART_RE.test(url)) {
          p.then(function (res) {
            if (res && res.ok) {
              var isAdd = /\/cart\/add/i.test(url);
              setTimeout(function () { refresh(isAdd); }, 50);
            }
          }).catch(function () {});
        }
        return p;
      };
    }

    /* ---------- intercepta mutaciones del carrito (XHR) ---------- */
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this._ttCartUrl = String(url || '');
      return origOpen.apply(this, arguments);
    };
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      var xhr = this;
      if (CART_RE.test(xhr._ttCartUrl || '')) {
        xhr.addEventListener('load', function () {
          if (xhr.status >= 200 && xhr.status < 300) {
            var isAdd = /\/cart\/add/i.test(xhr._ttCartUrl);
            setTimeout(function () { refresh(isAdd); }, 50);
          }
        });
      }
      return origSend.apply(this, arguments);
    };

    /* ---------- respaldo: evento nativo del tema ---------- */
    document.addEventListener('cartcount:update', function (e) {
      // Ignora el evento que dispara nuestro propio refresh (evita loop infinito).
      if (e.detail && e.detail._fromDrawer) return;
      refresh(false);
    });

    /* ---------- envío gratis + promesa de entrega: recalcular al elegir/cambiar comuna ---------- */
    function renderLoc() { renderShip(); renderDelivery(); }
    window.addEventListener('tt:loc', renderLoc);
    window.addEventListener('storage', function (e) { if (e.key === 'tt_loc') renderLoc(); });
    renderLoc(); // estado inicial (por si el carrito ya trae items al cargar)

    /* ---------- código de descuento (aplica vía /discount y va al checkout) ---------- */
    body.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-cd-discount]');
      if (!form) return;
      e.preventDefault();
      var input = form.querySelector('[data-cd-discount-input]');
      var code = (input && input.value || '').trim();
      if (!code) { if (input) input.focus(); return; }
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/checkout');
    });

    /* ---------- nota del pedido (guardado con debounce, SIN re-render) ---------- */
    var noteTimer;
    body.addEventListener('input', function (e) {
      var ta = e.target.closest('[data-cd-note]');
      if (!ta) return;
      var status = drawer.querySelector('[data-cd-note-status]');
      clearTimeout(noteTimer);
      noteTimer = setTimeout(function () {
        if (status) status.textContent = 'Guardando…';
        // usa origFetch para NO disparar el auto-refresh (la nota no cambia items)
        (origFetch || window.fetch)('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ note: ta.value })
        }).then(function () {
          if (status) { status.textContent = 'Nota guardada ✓'; setTimeout(function () { if (status) status.textContent = ''; }, 2000); }
        }).catch(function () { if (status) status.textContent = ''; });
      }, 700);
    });

    /* ---------- abrir con el ícono del carrito ---------- */
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-cart-drawer-open], .site-header-cart--button');
      if (opener) { e.preventDefault(); open(); return; }
      if (e.target.closest('[data-cart-drawer-close], [data-cart-drawer-overlay]')) { close(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    /* ---------- cantidad +/- y eliminar (delegación en el body) ---------- */
    body.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cd-qty], [data-cd-remove]');
      if (!btn || busy) return;
      e.preventDefault();
      var line = parseInt(btn.getAttribute('data-line'), 10);
      var qty = btn.hasAttribute('data-cd-remove') ? 0 : parseInt(btn.getAttribute('data-cd-qty'), 10);
      if (isNaN(line)) return;
      busy = true;
      body.classList.add('is-loading');
      // el propio fetch de abajo será interceptado y disparará refresh()
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      }).catch(function () { body.classList.remove('is-loading'); busy = false; });
    });
  });
})();
